import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function pickDefaultSeason(seasons = []) {
  if (!seasons.length) return null;
  const today = new Date();

  return (
    seasons.find((season) => {
      const start = new Date(season.start_date);
      const end = new Date(season.end_date);
      return season.registration_open || (start <= today && end >= today);
    }) || seasons[0]
  );
}

function ProfileBanner({ activeLeague, setActiveLeague, activeSeason, setActiveSeason }) {
  const [leagues, setLeagues] = useState([]);
  // const navigate = useNavigate();

  useEffect(() => {
    // Fetch active leagues
    axios.get('/api/leagues/active-leagues/', {
      withCredentials: true,
    })
      .then(response => {
        setLeagues(response.data);
        // Set the first league as the default active league if none is selected
        if (!activeLeague && response.data.length > 0) {
          const defaultLeague = response.data[0];
          setActiveLeague(defaultLeague);
          setActiveSeason(pickDefaultSeason(defaultLeague.seasons));
        }
      })
      .catch(error => {
        console.error('Error fetching leagues:', error);
      });
  }, [setActiveLeague, setActiveSeason, activeLeague]);

  const handleLeagueClick = (league) => {
    setActiveLeague(league);
    setActiveSeason(pickDefaultSeason(league.seasons));
  };

  return (
    <>
      {/* Card START */}
      <div className="card p-0">
        <div className="banner-img" style={{ backgroundColor: '#f8f9fa' }}>
          <img
            src={activeSeason && activeSeason.banner
              ? activeSeason.banner
              : `/static/images/kb_static/lemont_rec_league_banner.png`
            }
            alt="League Banner"
            className="w-100 h-auto rounded-top"
            style={{ maxHeight: '200px', objectFit: 'contain' }}
          />
        </div>

        {/* Card body START */}
        <div className="card-body py-0">
          <div className="d-sm-flex align-items-start">
            <div className="text-start">
              <div className="avatar avatar-xxl mt-n5 mb-3">
                <img
                  className="avatar-img rounded-circle border border-white border-3"
                  src={activeLeague && activeLeague.logo ? activeLeague.logo : `/static/images/kb_static/lemont_rec_leagues_circle.png`}
                  alt={activeLeague ? `${activeLeague.name} Logo` : 'Default avatar'}
                />
              </div>
            </div>
            <div className="ms-sm-4 mt-sm-3 text-center text-sm-start">
              {/* Display the active league's name */}
              <h1 className="mb-0 h5">
                {activeLeague ? activeLeague.name : 'Select a League'}{' '}
                <i className="bi bi-patch-check-fill text-success small"></i>
              </h1>
              <p>
                {activeSeason
                  ? `${activeSeason.name} (${activeSeason.start_date} - ${activeSeason.end_date})`
                  : ''}
              </p>
            </div>
          </div>
          <ul className="list-inline mb-0 text-center text-sm-start mt-3 mt-sm-0">
            <li className="list-inline-item">
              <i className="bi bi-geo-alt me-1"></i> Lemont, IL
            </li>
            <li className="list-inline-item">
              <i className="bi bi-calendar2-plus me-1"></i> Starting {activeSeason ? activeSeason.start_date : ''}
            </li>
          </ul>
        </div>
        {/* Card body END */}
        <div className="card-footer mt-3 pt-2 pb-0">
          <ul className="nav nav-bottom-line align-items-center justify-content-center justify-content-md-start mb-0 border-0">
            {leagues.map((league) => (
              <li key={league.id} className="nav-item">
                <button
                  className={`nav-link ${activeLeague && activeLeague.id === league.id ? 'active' : ''}`}
                  onClick={() => handleLeagueClick(league)}
                >
                  {league.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* Card END */}
    </>
  );
}

export default ProfileBanner;
